import React from 'react'
import { PortableText } from '@portabletext/react'

// https://github.com/portabletext/react-portabletext

const Content = ({ raw, components }) => !!raw && (
	<PortableText value={raw} components={components} />
)

const Richtext = ({ className, ...props }) => !!className
	? <div className={className}><Content {...props} /></div>
	: <Content {...props} />

export default Richtext
